import { usePersonnalisation } from '../hooks/usePersonnalisation';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  withText?: boolean;
  className?: string;
}

const sizes = {
  sm: { img: 'w-8 h-8', text: 'text-sm' },
  md: { img: 'w-10 h-10', text: 'text-base' },
  lg: { img: 'w-16 h-16', text: 'text-xl' },
};

export default function Logo({ size = 'md', withText = true, className = '' }: LogoProps) {
  const classes = sizes[size];
  // L'adresse porte l'horodatage du fichier : sans lui, un logo remplacé
  // resterait en cache dans les navigateurs pendant des jours.
  const perso = usePersonnalisation();

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <img
        // Le repli passe par le serveur : le fichier livré avec l'application
        // portait le logo d'une association en particulier, et paraissait
        // chez toutes les autres le temps qu'elles téléversent le leur.
        src={perso?.logoUrl ?? '/api/identite/icone'}
        alt={perso?.nomAssociation ? `Logo ${perso.nomAssociation}` : 'Logo de l’association'}
        className={`${classes.img} rounded-full object-contain shadow-sm`}
      />
      {withText && (
        <div className="leading-tight">
          {/* Le nom vient des réglages : l'application sert plusieurs
              associations, aucune n'a à porter le nom d'une autre en dur. */}
          <p className={`font-bold tracking-tight text-primary-700 ${classes.text}`}>
            {perso?.nomAssociation ?? 'Association'}
          </p>
          {perso?.sousTitre && (
            <p className="text-[10px] text-gray-500 dark:text-gray-400">{perso.sousTitre}</p>
          )}
        </div>
      )}
    </div>
  );
}
